import Vue from "vue";
import Vuex from "vuex";
import auth from "../app/auth/store";
import app from "../app/store";
import games from "../games/store";

Vue.use(Vuex);

import state from "./state";
import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    auth,
    app,
    games,
  },
});
